"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  item: {
    marginBottom: theme.spacing(3)
  },
  itemAccordion: {
    borderBottom: `1px solid ${theme.palette?.grey?.[300]}`,
    marginBottom: 0
  },
  accordion: {
    background: "none",
    borderRadius: "0 !important",
    boxShadow: "none"
  },
  accordionLabel: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0
  },
  accordionLabelContent: {
    flexDirection: "column"
  },
  accordionContent: {
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  },
  values: {
    display: "flex",
    justifyContent: "space-between"
  },
  value: {
    color: theme.palette?.primary?.main,
    fontSize: 14
  },
  slider: {
    marginLeft: 8,
    marginRight: 8,
    width: "calc(100% - 16px)"
  },
  sliderRail: {
    background: theme.palette?.grey?.[300],
    height: 6,
    marginLeft: -8,
    marginRight: -8
  },
  sliderThumb: {
    background: theme.palette?.secondary?.main,
    height: 16,
    marginLeft: -8,
    marginTop: -5,
    width: 16
  },
  sliderTrack: {
    background: theme.palette?.primary?.main,
    height: 6,
    marginLeft: -8,
    marginRight: -8
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));
var _default = exports.default = styles;